var map = {
	"./chalk.json": 27439,
	"./dark.json": 49924,
	"./infographic.json": 21048,
	"./macarons.json": 25590,
	"./shine.json": 21383,
	"./v5.json": 83977,
	"./walden.json": 73271,
	"./westeros.json": 90906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89003;